// Régularisation TOTALE d'un résumé ERA (cerfa_era_summary_data) = ligne K du 3310 (accise hors
// majoration ZNI, montant_ticfe_a_rembourser_ou_payer) + ligne N (majoration ZNI,
// montant_majoration_zni_a_regulariser, art. L312-37-1 CIBS). Négatif = à rembourser au client.
// Depuis le 03/11/2026 la majoration ZNI payée est séparée de K : tout calcul de remboursement,
// d'honoraires ou de prévisionnel doit sommer K + N, sinon il baisse de la part ZNI alors que le
// client est remboursé du même montant. Colonne N absente ou nulle → 0.
// Copie conforme de backend/src/utils/remboursementEra.js (garder les deux alignées).

const nombre = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

export function regularisationTotaleEra(resume) {
  if (!resume) return 0;
  return nombre(resume.montant_ticfe_a_rembourser_ou_payer) + nombre(resume.montant_majoration_zni_a_regulariser);
}
